module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/report.8615df9c.png";